import { render, staticRenderFns } from "./AppointmentDetailsCard.vue?vue&type=template&id=b6f1d560&scoped=true&"
import script from "./AppointmentDetailsCard.vue?vue&type=script&lang=js&"
export * from "./AppointmentDetailsCard.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentDetailsCard.vue?vue&type=style&index=0&id=b6f1d560&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f1d560",
  null
  
)

export default component.exports